import {faLayerGroup} from "@fortawesome/free-solid-svg-icons";

export default faLayerGroup;
